import css from 'styled-jsx/css'

import sizes from '../../../theme/sizes'


export default css`
  .floating-image {
    position: absolute;
    width: 350px;
    opacity: 0;
    transition: opacity .3s ease, transform .3s ease-out;
  }

  .floating-image.visible {
    opacity: 1
  }
`
